import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoggedInGuard } from '../../authentication/logged-in-guard.service';
import { LoggedOutGuard } from '../../authentication/logged-out-guard.service';
import { AuthService }    from '../../authentication/auth.service';
import { ViewcalenderComponent } from './viewcalender/viewcalender.component';

const routes: Routes = [
  {
    path: 'view',
    canActivate: [LoggedInGuard],
    component: ViewcalenderComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalenderRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/platform/calender/calender-routing.module.ts